import { Injectable } from '@angular/core';
import { NydusNetworkApiDataService } from '@rd/core/services/nydus-network-api-data/nydus-network-api-data.service';
import { UserFlags } from '@rd/types';
import { UserFlagsResponse } from '@rd/types/user-flag.response';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UserFlagsApiService {
  constructor(private nydusNetworkApiDataService: NydusNetworkApiDataService) {}

  getUserFlags(): Observable<UserFlags> {
    return this.nydusNetworkApiDataService
      .get<UserFlagsResponse>('flags')
      .pipe(
        map(
          (userFlagsResponse: UserFlagsResponse): UserFlags =>
            this.transformUserFlagsResponse(userFlagsResponse),
        ),
      );
  }

  transformUserFlagsResponse(userFlagsResponse: UserFlagsResponse): UserFlags {
    const count = userFlagsResponse.meta.count;
    const userFlags = userFlagsResponse.data;

    return {
      count,
      userFlags,
    };
  }
}
